import Component_AddingShadows_7443c02c8af59ba622bd80e756773632 from "../../../../content/guides/adding-shadows/AddingShadows";
import Devtool_AddingShadows_7443c02c8af59ba622bd80e756773632 from "!!@devtool/loader!../../../../content/guides/adding-shadows/AddingShadows";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_AddingShadows_7443c02c8af59ba622bd80e756773632,
  Devtool_AddingShadows_7443c02c8af59ba622bd80e756773632,
  DevTool,
  React
};